import WithFormData from './WithFormData';

export default WithFormData;
